import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { confirmPasswordReset } from 'firebase/auth';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';

@Component({
  imports: [FormsModule],
  selector: 'app-reset-password',
  template: `<input [(ngModel)]="newPassword" type="password" placeholder="New Password">
             <button (click)="resetPassword()">Save</button>`
})
export class ResetPasswordComponent implements OnInit {
  oobCode: string = '';
  newPassword: string = '';

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    // Extract oobCode from URL query params
    this.oobCode = this.route.snapshot.queryParamMap.get('oobCode') || '';
  }

  resetPassword() {
    if (!this.oobCode || !this.newPassword) return;

    // Confirm the reset using the oobCode and new password
    this.authService.confirmPasswordReset(this.oobCode, this.newPassword)
      .then(() => {
        alert('Password reset successfully!');
      })
      .catch((error) => {
        console.error('Reset failed:', error);
      });
  }
}   